/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import {
  Modal,
  Button,
  Space,
  Typography,
  Divider,
  DatePicker,
  Row,
  Col,
  Form,
  Input,
  Popconfirm,
} from "antd";
import moment from "moment";
import dayjs from "dayjs";
import { displayMessage, postAPI } from "../../utils/common";
import { ERROR_MSG_TYPE, SUCCESS_MSG_TYPE } from "../../constants/messages";
import { BOOKING_REGEN_INV_GRC, EDIT_BOOKING } from "../../constants/api";
import { useNavigate } from "react-router-dom";
import LS_SERVICE from "../../utils/localStorage";
const { Title } = Typography;

const BookingEditModal = ({ visible, onClose, booking }) => {
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const {
    checkin_date: defaultCheckinDate,
    checkout_date: defaultCheckoutDate,
    customer_name,
    booking_referred_name,
    customer_gst_no,
    booking_status,
  } = booking;

  const [selectedCheckoutDate, setSelectedCheckoutDate] =
    useState(defaultCheckoutDate);

  const [isProcessing, setIsProcessing] = useState(false);

  const handleSubmit = async (value) => {
    setIsProcessing(true);
    let body = {
      id: booking.id,
      checkout_date:
        moment(defaultCheckoutDate).format("YYYY-MM-DD") ===
        moment(selectedCheckoutDate).format("YYYY-MM-DD")
          ? null
          : moment(selectedCheckoutDate).format("YYYY-MM-DD"),
      customer_name: value.customer_name ?? null,
      booking_referred_name: value.booking_referred_name ?? null,
      customer_gst_no: value.customer_gst_no ?? null,
    };

    const successFn = function (data) {
      if (data.status === true) {
        setIsProcessing(false);
        displayMessage(SUCCESS_MSG_TYPE, data.message);
        onClose();
      } else {
        setIsProcessing(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setIsProcessing(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to submit");
    };
    postAPI(EDIT_BOOKING, body, successFn, errorFn);
  };

  const handleRegenAction = async (value) => {
    setIsProcessing(true);
    let body = {
      id: booking.id,
      update: value,
    };

    const successFn = function (data) {
      if (data.status === true) {
        setIsProcessing(false);
        displayMessage(SUCCESS_MSG_TYPE, data.message);
        onClose();
      } else {
        setIsProcessing(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setIsProcessing(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to submit");
    };
    postAPI(BOOKING_REGEN_INV_GRC, body, successFn, errorFn);
  };

  return (
    <Modal
      title="Edit Booking"
      open={visible}
      onCancel={onClose}
      footer={null}
      width={640}
      zIndex={1000000}
      loading={isProcessing}
    >
      <Divider />
      <Form
        initialValues={{
          customer_name,
          booking_referred_name,
          customer_gst_no,
        }}
        layout="vertical"
        form={form}
        onFinish={handleSubmit}
      >
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Title level={5}>Checkin Date</Title>
            <DatePicker
              disabled
              defaultValue={moment(defaultCheckinDate).startOf("day")}
              style={{ width: "100%" }}
            />
          </Col>
          <Col span={12}>
            <Title level={5}>Checkout Date</Title>
            <DatePicker
              disabled={booking_status == "2" || booking_status == "3"}
              key="checkout"
              value={
                selectedCheckoutDate
                  ? dayjs(selectedCheckoutDate)
                  : dayjs(defaultCheckoutDate)
              }
              onChange={(date) =>
                setSelectedCheckoutDate(
                  date ? date.format("YYYY-MM-DD") : defaultCheckoutDate
                )
              }
              disabledDate={(current) =>
                current && current < moment(defaultCheckinDate).startOf("day")
              }
              style={{ width: "100%" }}
            />
          </Col>
          <Col span={12}>
            <Form.Item
              name="customer_name"
              label="Customer Name"
              rules={[
                {
                  required: true,
                  message: "Please enter the customer's name",
                },
              ]}
            >
              <Input placeholder="Customer Name" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="booking_referred_name"
              label="Referred Name"
              rules={[
                {
                  required: false,
                  message: "Enter the Referred Name",
                },
              ]}
            >
              <Input placeholder="Referred Name" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="customer_gst_no"
              label="GST No"
              rules={[
                {
                  required: false,
                  message: "Enter the GST No",
                },
              ]}
            >
              <Input placeholder="GST No" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <Divider />

      <Button
        loading={isProcessing}
        onClick={() => {
          navigate("/customer/edit/" + booking.user_id);
        }}
        block
      >
        Edit Customer Detail
      </Button>

      <Divider />

      {LS_SERVICE.get("user_type") === "superAdmin" && booking_status === 2 && (
        <>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Popconfirm
                title="Regenerate Invoice Number?"
                description="Are you sure you want to regenerate the Invoice No? This will replace the old one."
                okText="Yes, Regenerate"
                cancelText="Cancel"
                onConfirm={() => handleRegenAction("invoice")}
              >
                <Button loading={isProcessing} block>
                  Re-generate Invoice No
                </Button>
              </Popconfirm>
            </Col>

            <Col span={12}>
              <Popconfirm
                title="Regenerate GRC Number?"
                description="Are you sure you want to regenerate the GRC No? This will replace the old one."
                okText="Yes, Regenerate"
                cancelText="Cancel"
                onConfirm={() => handleRegenAction("grc")}
              >
                <Button loading={isProcessing} block>
                  Re-generate GRC No
                </Button>
              </Popconfirm>
            </Col>

            <Col span={24}>
              <Popconfirm
                title="Regenerate Both Numbers?"
                description="Are you sure you want to regenerate both Invoice and GRC Numbers?"
                okText="Yes, Regenerate"
                cancelText="Cancel"
                onConfirm={() => handleRegenAction("both")}
              >
                <Button loading={isProcessing} block type="primary" danger>
                  Re-generate Both No
                </Button>
              </Popconfirm>
            </Col>
          </Row>

          <Divider />
        </>
      )}
      <Space style={{ width: "100%" }} direction="vertical">
        <Space style={{ float: "right" }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button
            style={{ marginLeft: 10 }}
            loading={isProcessing}
            onClick={form.submit}
            danger
          >
            Update the Given Detail
          </Button>
        </Space>
      </Space>
    </Modal>
  );
};

export default BookingEditModal;
